import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useTheme } from '../context/ThemeContext';
import { cn } from '../lib/utils';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={cn(
        "relative w-10 h-10 rounded-full flex items-center justify-center border transition-all duration-300 cursor-pointer select-none",
        isDark
          ? "bg-[#0c1324] border-brand-500/30 text-brand-400 hover:text-brand-300 hover:bg-[#131f38] hover:border-brand-400/60 shadow-[0_0_15px_rgba(var(--app-primary-rgb),0.25)] active:scale-95"
          : "bg-white border-slate-200 text-brand-600 hover:text-brand-700 hover:bg-brand-50/40 hover:border-brand-400/50 shadow-sm active:scale-95"
      )}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <AnimatePresence mode="wait" initial={false}>
        {isDark ? (
          <motion.div
            key="dark-moon"
            initial={{ opacity: 0, rotate: -90, scale: 0.6 }}
            animate={{ opacity: 1, rotate: 0, scale: 1 }}
            exit={{ opacity: 0, rotate: 90, scale: 0.6 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="flex items-center justify-center text-brand-400"
          >
            <Moon className="w-5 h-5 text-brand-400 drop-shadow-[0_0_8px_rgba(var(--app-primary-rgb),0.6)] stroke-[2.2]" />
          </motion.div>
        ) : (
          <motion.div
            key="light-sun"
            initial={{ opacity: 0, rotate: -90, scale: 0.6 }}
            animate={{ opacity: 1, rotate: 0, scale: 1 }}
            exit={{ opacity: 0, rotate: 90, scale: 0.6 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="flex items-center justify-center text-brand-600"
          >
            <Sun className="w-5 h-5 text-brand-600 drop-shadow-[0_0_8px_rgba(var(--app-primary-rgb),0.4)] stroke-[2.2]" />
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}

